import React from 'react';
import { Button, Divider, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import styles from './index.module.scss';
import Cards from './Cards';
import TopArticles from './TopArticles';
import RecentArticles from './RecentArticles';
import { useArticlesGet } from '../../../hooks/api/article';
import { useProductContext } from '../../../context/products';

export default function Home(): React.ReactNode {
  const navigate = useNavigate();
  const { loading } = useProductContext();

  return (
    <div className="wrapper">
      <div className={styles.content}>
        <Cards />
        <div className={styles.homeContent}>
          <TopArticles />
          <RecentArticles />
        </div>
      </div>
      {loading ? (
        <div className="spin">
          <Spin />
        </div>
      ) : null}
    </div>
  );
}
